<template>
    <a href="/basket"
       class="relative inline-block font-heading text-[15.75px] font-medium text-stockbee-text hover:text-stockbee-yellow transition-colors duration-300">
        Basket
        <span v-if="count > 0"
              class="absolute -top-2 -right-3 bg-stockbee-yellow text-stockbee-dark text-xs rounded-full px-2 py-0.5 font-bold">
            {{ count }}
        </span>
    </a>
</template>

<script>
export default {
    data() { return { count: 0 }; },
    async mounted() {
        await this.refresh();
        window.addEventListener('basket-updated', this.refresh);
    },
    beforeDestroy() {
        window.removeEventListener('basket-updated', this.refresh);
    },
    methods: {
        async refresh() {
            try {
                const { data } = await window.axios.get('/basket/count');
                this.count = data.count || 0;
            } catch (e) {
                this.count = 0;
            }
        },
    },
};
</script>
